import { createContext, useContext, type ReactNode } from "react";
import { useAdminStatusState } from "@/hooks/useAdminStatusState";

export interface AdminStatusValue {
  isAdmin: boolean;
  isLoading: boolean;
  refreshAdminStatus: () => Promise<void>;
}

const AdminStatusContext = createContext<AdminStatusValue | null>(null);

const defaultValue: AdminStatusValue = {
  isAdmin: false,
  isLoading: false,
  refreshAdminStatus: async () => {},
};

export function AdminStatusProvider({ children }: Readonly<{ children: ReactNode }>) {
  const value = useAdminStatusState();
  return <AdminStatusContext.Provider value={value}>{children}</AdminStatusContext.Provider>;
}

export function useAdminStatus(): AdminStatusValue {
  const ctx = useContext(AdminStatusContext);
  return ctx ?? defaultValue;
}
